import React from 'react';
import { Tooltip } from '@mui/material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import ComputerIcon from '@mui/icons-material/Computer';

// Item 7 fase 2 (multi-dispositivo): ícone da classe da sessão (desktop | mobile). Uma vaga de login por classe.
const DeviceIcon = ({ kind, intl, t }) => {
  const mobile = kind === 'mobile';
  const label = t ? t(intl, mobile ? 'session.device.mobile' : 'session.device.desktop', mobile ? 'Celular' : 'Computador') : (mobile ? 'Celular' : 'Computador');
  const Icon = mobile ? SmartphoneIcon : ComputerIcon;
  return (
    <Tooltip title={label}>
      <Icon fontSize="small" style={{ verticalAlign: 'middle', marginRight: 6, color: mobile ? '#277afe' : '#777' }} />
    </Tooltip>
  );
};

export default DeviceIcon;
